import { render, staticRenderFns } from "./ModifyQuotationPackageModal.vue?vue&type=template&id=8fe1b084&scoped=true&"
import script from "./ModifyQuotationPackageModal.vue?vue&type=script&lang=js&"
export * from "./ModifyQuotationPackageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe1b084",
  null
  
)

export default component.exports